import { Language } from 'types/lang';

export { GOOGLE_ANALYTICS, GOOGLE_ANALYTICS_GLOBAL, GTM_GLOBAL } from '../locales/gtm';
